var __s__ = require('./support-fns.js');
// var THREE = require('three');

//Class Connector
export class Connector {

    constructor (name, parentJaw, obj1, obj2) {
        let me = this,
            sphereMaterial = new THREE.MeshPhongMaterial( {color: parentJaw.scene.options.colors.connectorSphere }),
            sphereGeometry = new THREE.SphereGeometry(0.12, 32, 32), finalPos,
            lineGeometry, line1, line2, path, points, curve, controlPoint, dist, sqSide, vec, ang,
            lineMaterial = new THREE.LineBasicMaterial({ color: parentJaw.scene.options.colors.connection,
                linewidth: parentJaw.scene.options.connectionLineWidth });
        const SUBDIVISIONS = 20 * parentJaw.scene.options.connectionLineWidth;


        function createSphereAndLines(group, adjustPosition, isLeftReversed = false) {
            let sphere = new THREE.Mesh(sphereGeometry, sphereMaterial),
                pos1 = obj1.object3D.theCrown.position,
                pos2 = obj2.object3D.theCrown.position,
                pos1F, pos2F,
                pos = new THREE.Vector3(
                            (pos1.x + pos2.x) / 2, //x
                            parentJaw.upper ? -0.5 : 0.3, //y
                            (pos1.z + pos2.z) / 2 //z
                        ).multiplyScalar(-1);

            function createLine(posTo, isLeft = true) {
                let posF = sphere.position.clone().add(posTo.clone().sub(sphere.position.clone()).multiplyScalar(0.8));
                let angSphere = new THREE.Vector2(pos.x, pos.z).sub(new THREE.Vector2(sphere.position.x, sphere.position.z)).angle();

                //Calculate Bezier Control
                vec = new THREE.Vector2(posF.x - sphere.position.x, posF.z - sphere.position.z);
                dist = vec.lengthSq();
                sqSide = Math.sqrt(dist / 2);
                ang = vec.angle();
                ang = angSphere + (isLeft ? 1 : -1) * Math.PI / 2 * (obj1.upper ? 1 : -1) * (isLeftReversed ? -1 : 1);
                controlPoint = new THREE.Vector3(Math.cos(ang) * sqSide, 0, Math.sin(ang) * sqSide)
                    .add(sphere.position.clone());

                //Create curve
                curve = new THREE.QuadraticBezierCurve3();
                curve.v0 = new THREE.Vector3(sphere.position.x, posTo.y, sphere.position.z);
                curve.v1 = controlPoint;
                curve.v2 = new THREE.Vector3(posF.x, posTo.y, posF.z);

                lineGeometry = new THREE.Geometry();
                for (let j = 0; j < SUBDIVISIONS; j+= 1) {
                    lineGeometry.vertices.push(curve.getPoint(j / SUBDIVISIONS));
                }

                line1 = new THREE.Line(lineGeometry, lineMaterial);
                line1.parentConnection = "cn_" + name;
                group.lines.add(line1);
            }

            //Sphere
            sphere.parent = me;
            sphere.name = "cn_" + name;
            sphere.parentConnection = "cn_" + name;

            finalPos = adjustPosition(pos);
            sphere.position.set(finalPos.x, finalPos.y, finalPos.z);
            group.add(sphere.clone());

            pos1 = pos1.clone().multiplyScalar(-1);
            pos1.y = parentJaw.upper ? 0.5 : -0.3;
            pos2 = pos2.clone().multiplyScalar(-1);
            pos2.y = parentJaw.upper ? 0.5 : -0.3;

            //Line 1
            if (Number(obj1.numberUNS) < Number(obj2.numberUNS)) {
                createLine(pos1, true);
            } else {
                createLine(pos2, true);
            }

            //Line 2
            if (Number(obj1.numberUNS) > Number(obj2.numberUNS)) {
                createLine(pos1, false);
            } else {
                createLine(pos2, false);
            }
        }


        this.jaw = parentJaw;
        this.name = name;
        this.isOn = false;
        this.sphereMaterial = sphereMaterial;
        this.lineMaterial = lineMaterial;

        //Create 3D Holders
        this.object3d = new THREE.Group();
        this.object3d.inside = new THREE.Group();
        this.object3d.outside = new THREE.Group();
        this.object3d.inside.lines = new THREE.Group();
        this.object3d.outside.lines = new THREE.Group();

        this.object3d.inside.visible = false;
        this.object3d.outside.visible = false;

        //Add to rendering
        this.object3d.add(this.object3d.inside);
        this.object3d.add(this.object3d.outside);
        this.object3d.inside.add(this.object3d.inside.lines);
        this.object3d.outside.add(this.object3d.outside.lines);

        //Hide lines (only show when connected)
        this.object3d.inside.lines.visible = false;
        this.object3d.outside.lines.visible = false;

        createSphereAndLines(
            this.object3d.inside,
            function(pos) {
                return new THREE.Vector3(
                    pos.x * 0.7,
                    pos.y,
                    pos.z * 0.9 - 0.1
                );
            },
            false
        );

        createSphereAndLines(
            this.object3d.outside,
            function(pos) {
                return new THREE.Vector3(
                    pos.x * 1.3,
                    pos.y,
                    pos.z * 1.1 + 0.2
                );
            },
            true
        );
    }

    toggleVisibility(ofInside, ofOutside) {
        this.object3d.inside.visible = !!ofInside;
        this.object3d.outside.visible = !!ofOutside;
    }

    toggleConnectorColor(toggle) {
        let sphereMaterial, lineMaterial;
        if (toggle) {

            sphereMaterial = new THREE.MeshPhongMaterial( {color: this.jaw.scene.options.colors.connection });
            lineMaterial = new THREE.LineBasicMaterial({ color: this.jaw.scene.options.colors.connection,
                linewidth: 3 });

            this.isOn = true;
            this.object3d.inside.lines.visible = true;
            this.object3d.outside.lines.visible = true;

        } else {

            sphereMaterial = this.sphereMaterial;
            lineMaterial = this.lineMaterial;
            this.isOn = false;
            this.object3d.inside.lines.visible = false;
            this.object3d.outside.lines.visible = false;
        }

        this.object3d.traverse(function(child){
            if (child.type === "Mesh") {
                child.material = sphereMaterial;
                child.needsUpdate = true;
            }
        });

    }
}
